<script>
    import { Router, Link, Route } from "svelte-routing";
    import ListRoute from "./list/index.html";
    import AddUpdate from "./addupdate/index.html";
    import ArchievedList from "./archievedList/index.html";
    import MODULES from "../utils/modules.js" 
    import Forbidden from "../forbidden.html"
</script>

<Router>

    
    <Route path="info/:id" let:params>
        {#if MODULES.hasAccess(MODULES.VIEW_ENQUIRY_DETAILS)}
        <AddUpdate _id="{params.id}"></AddUpdate>
        {:else}
        <Forbidden />
        {/if}
    </Route>
    <Route path="archived">
        <ArchievedList ></ArchievedList>
    </Route>
    <Route path="">
        <ListRoute></ListRoute>
    </Route>
</Router>



